import { Inject, Injectable } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { Observable, ReplaySubject } from 'rxjs';

@Injectable()
export class CopyToClipboardService {
  private dom: Document;

  constructor(
    @Inject(DOCUMENT) dom: Document,
  ) {
    this.dom = dom;
  }

  // I copy the given value to the user's system clipboard. Returns a Observable that
  // resolves to the given value on success or rejects with the raised Error.
  public copy(value: string): Observable<string> {
    const result = new ReplaySubject<string>(1);

    let textarea: HTMLTextAreaElement;

    try {
      textarea = this.dom.createElement('textarea');
      textarea.style.position = 'absolute';
      textarea.style.opacity = '0';
      textarea.style.left = '0px';
      textarea.style.top = '0px';
      textarea.style.width = '0px';
      textarea.style.height = '0px';
      this.dom.body.appendChild(textarea);

      // Set and select the value (creating an active Selection range).
      textarea.value = value;
      textarea.select();

      // Ask the browser to copy the current selection to the clipboard.
      this.dom.execCommand('copy');

      result.next(value);
    } catch (e) {
      result.thrownError(e);
    } finally {
      // Cleanup - remove the Textarea from the DOM if it was injected.
      if (textarea && textarea.parentNode) {
        textarea.parentNode.removeChild(textarea);
      }
    }

    return result.asObservable();
  }
}
